const getSelectedCampaignForPlatform = (selectedCampaigns, campaignData, platformName) => {
	let masterCampaignID = null;
	let activationCampaignID = null;
	if (selectedCampaigns) {
		for (let i = 0; i < Object.entries(selectedCampaigns).length; i++) {
			const [masterCampaignId, activationCampaigns] = Object.entries(selectedCampaigns)[i];
			const campaign = Object.entries(activationCampaigns).find(([acivationCampaignId, isSelected]) => {
				return isSelected == true;
			});
			if (campaign && campaign.length == 2 && campaign[1]) {
				masterCampaignID = masterCampaignId;
				activationCampaignID = campaign[0];
				break;
			}
		}

		const masterCampaign = campaignData.find(({ MasterCampaignID }) => MasterCampaignID == masterCampaignID);
		if (masterCampaign) {
			if (platformName) {
				// if the caller tells us which platform the target campaign is in
				return masterCampaign.ActivationCampaigns[platformName].find(({ CampaignID }) => CampaignID == activationCampaignID);
			}
			// if not, check all the platforms.
			const platforms = Object.values(masterCampaign.ActivationCampaigns);
			for (let i = 0; i < platforms.length; i++) {
				const platformCampaigns = platforms[i];
				const target = platformCampaigns.find(({ CampaignID }) => CampaignID == activationCampaignID);
				if (target) {
					return target;
				}
			}
		}
	}
	// default return empty object if not found
	return {};
};

export const getUpdatedCampaignDataPostPush = ({ data, selectedCampaigns }, payload, platformName) => {
	const originalData = [...data];
	const { ParentUniqueIDcode, CampaignID } = getSelectedCampaignForPlatform(selectedCampaigns, originalData, platformName);
	if (ParentUniqueIDcode && CampaignID) {
		const masterCampaignIndex = originalData.findIndex(({ MasterCampaignID }) => MasterCampaignID == ParentUniqueIDcode);
		const activationCampaignIndex = originalData[masterCampaignIndex].ActivationCampaigns[platformName].findIndex(
			(activationCampaign) => CampaignID == activationCampaign.CampaignID
		);

		const targetCampaign = originalData[masterCampaignIndex].ActivationCampaigns[platformName][activationCampaignIndex];
		originalData[masterCampaignIndex].ActivationCampaigns[platformName][activationCampaignIndex] = {
			...targetCampaign,
			...payload
		};
	}

	return originalData;
};
